import { useMemo } from 'react';
import {
  SECURE911_OSN,
  SECURE911_OSN_ADR,
} from '@rsos/capstone/src/constants/capabilities';
import useHasCapability from '@rsos/hooks/useHasCapability';
import useHasPermission from '@rsos/hooks/useHasPermission';
import { SECURE911_PERMISSION } from '../constants/permissions';

const useHasAccessToSecure911 = () => {
  const hasSecure911OsnCapabilities = useHasCapability([
    SECURE911_OSN,
    SECURE911_OSN_ADR,
  ]);
  const hasSecure911Permission = useHasPermission(SECURE911_PERMISSION);

  const hasAccessToSecure911Feature = useMemo(() => {
    return (
      !!hasSecure911OsnCapabilities?.hasCapability &&
      !!hasSecure911Permission?.hasPermission
    );
  }, [hasSecure911OsnCapabilities, hasSecure911Permission]);
  return hasAccessToSecure911Feature;
};

export default useHasAccessToSecure911;
